<script lang="ts" setup>
  import { navbarData, lp1Data, seoData } from '~/data'

  useHead({
    title: 'Thaís Baêta - Advocacia Trabalhista',
    meta: [
      {
        name: 'description',
        content:
          'Advocacia Trabalhista com foco em direitos dos trabalhadores, incluindo estabilidade gestacional, reversão de demissão por justa causa, rescisão indireta, pagamentos de adicinais de insalubridade e periculosidade e danos morais.',
      },
    ],
    link: [
      {
        rel: 'canonical',
        href: `${seoData.mySite}`,
      },
    ],
  })

  // Generate OG Image
  const siteData = useSiteConfig()
  defineOgImage({
    props: {
      title: navbarData.homeTitle,
      description:
        'Advocacia Trabalhista com foco em direitos dos trabalhadores, incluindo estabilidade gestacional e outros.',
      siteName: siteData.url,
    },
  })

  defineRouteRules({
    sitemap: {
      changefreq: 'monthly',
      priority: 0.3,
      lastmod: '2025-08-05',
    },
  })

  const clickAccordion = (event: Event) => {
    const header = event.currentTarget as HTMLElement;
    const body = header.nextElementSibling as HTMLElement; // Get the next sibling (the body)
    body.classList.toggle('hidden'); // Toggle the 'hidden' class
  };

  const accordionItems = ref([]);
  accordionItems.value = [
    { id: 1, title: 'Até quando posso dar entrada na causa?', content: 'Você tem pressa em pagar suas contas? Você e sua família estão precisando de dinheiro? Pois é, a necessidade é toda sua e seu patrão vai adorar se você demorar. Além disso na lei diz que se você der entrada na causa fora prazo correto, você pode perder todos seus direitos, isso mesmo, TODOS SEUS DIREITOS. Cuidado.' },    
    { id: 2, title: 'Minha causa é ganha?', content: 'A Justiça do Trabalho é o lugar certo para combater as injustiças contra o trabalhador, então se seu patrão fez alguma coisa errada contra você somente no processo judicial você terá a garantia de conseguir seus direitos corretamente. E somente um advogado trabalhista especializado pode ajudar você nessa luta. Se você for por outro caminho vai se arrepender.' },
    { id: 3, title: 'Qualquer advogado pode me ajudar?', content: 'Não! De jeito nenhum! Você quando tem um dor de dente procura um dentista ou vendedor de frutas? Então como você quer entregar a defesa do seu direito nas mãos de um advogado que não é trabalhista? Pois é, apenas advogado especialista em direito trabalhista e com grande experiência na defesa do trabalhador saberá defender você corretamente. Experiência é a chave do sucesso nas causas trabalhistas, e eu tenho quase 15 anos de advocacia e já atuei em centenas de processos.' },
    { id: 4, title: 'Terei que pagar quanto ao Sr. para dar entrada?', content: 'Nada! Você não vai pagar nada para mim, para dar entrada. Eu acredito no seu direito e na minha capacidade como advogado, por isso só vou receber se você ganhar a causa. Vou junto com você nessa luta. Vamos vencer juntos. Isso mesmo, receberei meus honorários só quando você ganhar seu dinheiro.' },
    { id: 5, title: 'Meu atendimento será pela internet? É tudo assim?', content: 'Tenho certeza que você já foi em algum médico e ficou horas e horas esperando seu atendimento. Eu respeito muito seu tempo e seu conforto, por isso você não precisa perder horas no trânsito e nem gastar para falar comigo. Nosso contato será todo pelo WhatsApp (Zap), você vai falar comigo do mesmo jeito que conversa com seus amigos. Você vai se sentir mais próximo de mim do que se a gente tivesse frente a frente.' },
    { id: 6, title: 'Sou de outra cidade ou estado. Como será meu atendimento?', content: 'Não muda nada. Essa é a vantagem do atendimento totalmente pela internet. Se você quiser falar comigo, basta apertar um botão e pronto. E quando tiver sua audiência você estará acompanhando por um advogado da minha equipe.' },
    { id: 7, title: 'Como acompanharei o processo?', content: 'Até mesmo seu processo é pela internet. Todo processo novo é 100% na internet. Você sabia disso? É por isso também que nosso atendimento e conversas com você será 100% pela internet. E você poderá acompanhar o andamento do seu processo através da minha equipe. É simples e fácil.' },
    { id: 8, title: 'Eu posso dar entrada na causa mesmo se ainda não foi demitido?', content: 'Sim, pode sim. E seu patrão não pode demitir você por isso. Te explico melhor no WhatsApp (Zap).' },
    { id: 9, title: 'Qual o valor da minha causa, dos meus direitos?', content: 'Fique tranquilo. Quando um cliente me contrata ele já sabe o valor aproximado dos seus direitos. Esse é um bônus do meu serviço.' },
    { id: 10, title: 'Como faço para contratar seu serviço de advogado ou falar com o Senhor?', content: 'Basta clicar no botão “FALAR COM ESPECIALISTA”. Você vai ser direcionado para meu WhatsApp (ZAP). Pronto, depois resolvemos tudo por lá. Só isso!!!' },
    { id: 'reconhecimento-vinculo', title: 'Trabalha sem carteira assinada?<br />Peça o reconhecimento do vínculo', content: 'Basta clicar no botão “FALAR COM ESPECIALISTA”. Você vai ser direcionado para meu WhatsApp (ZAP). Pronto, depois resolvemos tudo por lá. Só isso!!!' }
  ];

  const services = ref([
    {
      id: 1,
      title: 'Trabalha sem carteira assinada?<br />Peça o reconhecimento do vínculo'
    },
    {
      id: 2,
      title: 'Foi demitido? Verifique se você<br />recebeu todos os seus direitos'
    },
    {
      id: 3,
      title: 'Foi demitido por justa causa?<br />Podemos te ajudar'
    },
    {
      id: 4,
      title: 'Desvio ou acúmulo de função'
    },
    {
      id: 5,
      title: 'Foi demitida grávida?<br />Podemos te ajudar'
    },
    {
      id: 6,
      title: 'Salário atrasado'
    },
    {
      id: 7,
      title: 'Pedido de horas extras'
    },
    {
      id: 8,
      title: 'Insalubridade e Periculosidade'
    },
    {
      id: 9,
      title: 'FGTS atrasado'
    },
    {
      id: 10,
      title: 'Trabalho em domingos e feriados'
    },
    {
      id: 11,
      title: 'Sofreu acidente do trabalho'
    },
    {
      id: 12,
      title: 'Adquiriu doença trabalhando'
    },
    {
      id: 13,
      title: 'Quero saber os cálculos da minha rescisão'
    },
    {
      id: 14,
      title: 'Assédio moral ou sexual no trabalho'
    }
  ]);

  const diferenciais = ref([
    {
      id: 1,
      icon: 'hugeicons:award-02',
      title: '15 anos de<br />experiência',
    },
    {
      id: 2,
      icon: 'hugeicons:award-05',
      title: 'Clientes totalmente<br />satisfeitos',
    },
    {
      id: 3,
      icon: 'hugeicons:manager',
      title: 'Equipe altamente<br />capacitada',
    },
    {
      id: 4,
      icon: 'hugeicons:chatting-01',
      title: 'Atendimento online<br />e imediato',
    },
  ]);
</script>

<template>
  <div class="max-w mx-auto text-zinc-600">
    <div class="grid grid-cols-1 py-2 sm:py-10 h-[500px] bg-[url('/bg-home-header.jpg')]">
      <div class="px-10 sm:px-20 lg:px-40 text-center">
        <h1
          class="text-white dark:text-zinc-300 font-semibold leading-tight text-3xl sm:text-4xl md:text-5xl my-14"
        >
          {{ lp1Data.title }}
        </h1>
        <h2 class="text-white dark:text-zinc-300 leading-tight text-2xl sm:text-3xl md:text-4xl my-5">
          {{ lp1Data.subtitle }}
        </h2>
        <p class="text-white text-xl sm:text-2xl dark:text-zinc-300 mt-14">
          {{ lp1Data.description }}
        </p>

        <div class="py-14 flex justify-center">
          <button
            href="#lista-de-espera"
            class="bg-[#12B14D] hover:bg-[#0e9440] text-white font-bold py-4 px-8 rounded-full flex items-center">
              <Icon name="logos:whatsapp-icon" />&nbsp;&nbsp;
              <b>FALE COM UM ADVOGADO</b> &nbsp; especialista &nbsp; <b>AGORA POR WHATSAPP</b></button>
        </div>
      </div>
    </div>
    <div class="max-w mx-auto my-8 flex justify-center">    
      <div class="container grid grid-cols-1 lg:grid-cols-4 sm:grid-cols-2 my-5 p-5 bg-zinc-300 dark:bg-slate-800 border border-zinc-300 rounded-2xl shadow-lg">
        <div v-for="diferencial in diferenciais" :key="diferencial.id" class="text-center w-full mb-5">
          <Icon :name="diferencial.icon" size="3em" />
          <h3
            class="text-black dark:text-zinc-300 font-semibold leading-tight text-md sm:text-lg md:text-xl"
          >            
            <span v-html="diferencial.title"></span>
          </h3>
        </div>
      </div>
    </div>
    <div class="max-w mx-auto my-24">
      <div class="text-center">
        <h2 class="text-zinc-800 dark:text-zinc-300 leading-tight text-3xl sm:text-4xl md:text-5xl my-14">Conte conosco para solucionar o seu caso</h2>
      </div>
      <div
        class="container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 items-center flex mx-auto"
      >
        <div v-for="service in services" :key="service.id" class="text-center bg-[#c4cce8] border border-[#263159] text-red-700 px-4 py-3 rounded relative shadow-lg mx-3 mb-6" role="alert">
          <h3
            class="text-black dark:text-zinc-300 font-medium leading-tight text-sm sm:text-md md:text-lg"
          >            
            <span v-html="service.title"></span>
          </h3>          
        </div>        
      </div>      
    </div>
    <div class="grid grid-cols-1 my-10 py-10 h-auto bg-[#263159]">
      <div class="px-10 sm:px-20 lg:px-40 text-center">
        <h2
          class="text-white dark:text-zinc-300 font-semibold leading-tight text-2xl sm:text-3xl md:text-4xl my-5"
        >
          Não deixe os seus direitos de lado!
        </h2>
        <div class="py-14 flex justify-center">
          <button
            href="#lista-de-espera"
            class="bg-[#12B14D] hover:bg-[#0e9440] text-white font-bold py-4 px-8 rounded-full flex items-center">
              <Icon name="logos:whatsapp-icon" />&nbsp;&nbsp;
              <b>FALE COM UM ADVOGADO</b> &nbsp; especialista &nbsp; <b>AGORA POR WHATSAPP</b></button>
        </div>
      </div>
    </div>
    <div class="max-w mx-auto my-10">
      <div class="max-w-sm w-full lg:max-w-full lg:flex justify-center">
        <div class="h-48 lg:h-96 lg:w-96 flex-none bg-cover rounded-lg rounded-bl-[30%] text-center overflow-hidden bg-[url('/quem-somos.jpg')]" title="Justiça do Trabalho">
          <!-- Image -->
        </div>
        <div class="border rounded-lg p-4 flex flex-col justify-between leading-normal w-[33%]">
          <div class="mb-8">            
            <h2 class="text-gray-900 font-bold text-4xl mb-2">Quem Somos?</h2>
            <p class="text-gray-700 text-base text-xl my-10">
              Advocacia especializada em Direito do Trabalho, com atendimento presencial em Vitória/ES e online para todo o Brasil.
              <br /><br />
              Com 15 anos de experiência, o escritório também atua como correspondente jurídico em toda Grande Vitória.
            </p>
          </div>          
        </div>
      </div>
    </div>
    <div class="container max-w mx-auto my-10">
      <div class="text-center">
        <h2 class="text-zinc-800 dark:text-zinc-300 leading-tight text-3xl sm:text-4xl md:text-5xl my-14">Perguntas Frequentes</h2>
      </div>
      <div>
        <div class="w-full mx-auto lg:max-w-4xl md:max-w-2xl sm:max-w-xl">
          <div v-for="item in accordionItems" :key="item.id" class="border-b border-b-gray-300 mb-2">
            <button :id="`${item.id}`" class="accordion-header w-full text-left text-lg text-[#263159] p-4 font-bold" @click="clickAccordion">
              <Icon name="mdi:chevron-down" class="inline-block mr-2" />
              <span v-html="item.title"></span>
            </button>
            <div class="accordion-body p-4 hidden">
              <p>{{ item.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-1 my-10 py-10 h-auto bg-[#263159]">
      <div class="px-10 sm:px-20 lg:px-40 text-center">
        <h2
          class="text-white dark:text-zinc-300 font-semibold leading-tight text-2xl sm:text-3xl md:text-4xl my-5"
        >
          PRECISANDO DE AJUDA?
          <br />
          ENTRE EM CONTATO
        </h2>
        <div class="py-14 flex justify-center">
          <button
            href="#lista-de-espera"
            class="bg-[#12B14D] hover:bg-[#0e9440] text-white font-bold py-4 px-8 rounded-full flex items-center">
              <Icon name="logos:whatsapp-icon" />&nbsp;&nbsp;
              <b>FALE COM UM ADVOGADO</b> &nbsp; especialista &nbsp; <b>AGORA POR WHATSAPP</b></button>
        </div>
      </div>
    </div>
    <div class="max-w mx-auto my-10">
      <div class="max-w-sm w-full lg:max-w-full lg:flex justify-center">
        <div class="h-48 lg:h-96 lg:w-96 flex-none bg-cover rounded-2xl text-center overflow-hidden bg-[url('/vitoria-mapa.jpg')]" title="Mapa de Vitória - ES">
          <!-- Image -->
        </div>
        <div class="border rounded-lg p-4 flex flex-col justify-between leading-normal w-[33%] ml-10">
          <div class="mb-8">            
            <h2 class="text-gray-900 font-bold text-4xl mb-2">Dados de Contato</h2>
            <ul class="text-gray-700 text-base text-xl my-10">                            
              <li class="mb-4">
                <Icon name="mdi:email" class="inline-block mr-2" />
                <a href="mailto:contato@baetaadvocacia.com.br" class="hover:underline">contato@baeta.adv.br</a>
              </li>
              <li class="mb-4">
                <Icon name="mdi:whatsapp" class="inline-block mr-2" />
                <a href="https://wa.me/5527981032744" target="_blank" class="hover:underline">+55 (27) 98103-2744</a>
              </li>
              <li class="mb-4">
                <Icon name="mdi:clock" class="inline-block mr-2" />
                Atendimento: Segunda a Sexta, das 9h às 18h
              </li>
              <li class="mb-4">
                <Icon name="mdi:web" class="inline-block mr-2" />
                <a href="https://www.baeta.adv.br" target="_blank" class="hover:underline">www.baeta.adv.br</a>
              </li>
              <li class="mb-4">
                <Icon name="mdi:instagram" class="inline-block mr-2" />
                <a href="https://www.instagram.com/baetaadv" target="_blank" class="hover:underline">@baetaadv</a>
              </li>              
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>